/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix } from './constants';

/**
 * TODO: 其他系统使用
 * Studio页面Community接口
 * @param payload
 * @returns
 */
export const getStudioCommunity: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/community`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * Studio页面GameStore接口
 * @param payload
 * @returns
 */
export const getStudioGameStore: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/game_store`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * Studio页面，获取keyword卡片数据
 * @param payload
 * @returns
 */
export const getStudioKeywordEvent: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/keyword_event`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * 获取languages和channel数据
 * @param payload
 * @returns
 */
export const getStudioLanguageChannel: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/language_channel`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * 获取Official Accounts数据
 * @param payload
 * @returns
 */
export const getStudioAccounts: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/accounts`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * 获取PR统计图数据
 * @param payload
 * @returns
 */
export const getStudioNews: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/news`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * 获取模块右上角的标签信息
 * @param payload
 * @returns
 */
export const getStudioCompetitorRank: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/competitor_rank`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * 获取influencers卡片数据
 * @param payload
 * @returns
 */
export const getStudioInfluencers: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/influencers`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * Studio页面Google Trend 接口
 * @param payload
 * @returns
 */
export const getStudioGoogleTrends: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/studio/google_trends`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
